export const stateName = 'items';
export const PER_PAGE = 20;
export const CATALOG_PER_PAGE = 96;
export const CATALOG_FETCH_ITEM_DEBOUNCE_AMOUNT = 100;
export const MAX_OWNER_ITEMS_PER_PAGE = 24;
export let ItemUiView;

(function (ItemUiView) {
  ItemUiView["UserItems"] = "userItems";
  ItemUiView["UserBundleItems"] = "userBundleItems";
  ItemUiView["FavouriteItems"] = "favouriteItems";
  ItemUiView["SimilarItems"] = "similarItems";
  ItemUiView["CatalogItems"] = "catalogItems";
  ItemUiView["RecommendedItems"] = "recommendedItems";
})(ItemUiView || (ItemUiView = {}));